import { commonChecks } from '@xhs/ozone-detector';
import { addCallback } from '../lib/callbacks';
import { validateReq, validateRes } from '../utils/check';
import { SchemaType } from '../utils/type';
import { addCalledJsListener, generateCalledJsCallback, removeCalledJsListener } from '../lib/event';
import SchemaError from '../utils/SchemaError';
import { SchemaErrorCode, } from '../interface';
import { transformRes } from '../utils/transform';
import { addMeasure } from '../utils/addMeasure';
function isSupportInvoke() {
    const handler = commonChecks.isIOS ? window?.webkit?.messageHandlers : window?.XHSBridge;
    return handler && !!handler.invoke;
}
/**
 * Web平台Bridge方法请求
 * @param method Bridge方法名
 * @param args Bridge方法参数
 */
export function invoke(method, args) {
    const startTime = Date.now();
    return new Promise((resolve, reject) => {
        try {
            // 是否支持新版本的写法
            if (!isSupportInvoke()) {
                throw new SchemaError(SchemaErrorCode.NotSupport, 'not support invoke');
            }
            validateReq(method, SchemaType.Method, args);
            const callback = addCallback(method, (res) => {
                try {
                    const businessRes = transformRes(method, res);
                    validateRes(method, SchemaType.Method, businessRes);
                    // 只上报成功bridge的耗时
                    addMeasure({
                        platformType: 'H5',
                        bridgeName: method,
                        timing: Date.now() - startTime,
                    });
                    resolve(businessRes);
                }
                catch (error) {
                    addMeasure({
                        platformType: 'H5',
                        bridgeName: method,
                        isError: true,
                        errorInfo: error.message || `${method} call error`,
                    });
                    reject(error);
                }
            });
            const postData = {
                method,
                callback,
                args,
            };
            try {
                if (commonChecks.isIOS) {
                    window.webkit.messageHandlers.invoke.postMessage(postData);
                }
                else {
                    window.XHSBridge.invoke(JSON.stringify(postData));
                }
            }
            catch (error) {
                throw new SchemaError(SchemaErrorCode.Native, error.message);
            }
        }
        catch (error) {
            if (!(error instanceof SchemaError)) {
                reject(new SchemaError(SchemaErrorCode.UnKnow, error.message || `[ozone-bridge] [${method}] call error`));
            }
            else {
                reject(error);
            }
        }
    });
}
/**
 * Web 平台添加event的监听
 * @param eventName 监听的事件名
 * @param callback 收到事件的回调
 */
export function subscribe(eventName, callback) {
    // callback添加到事件监听列表
    addCalledJsListener(eventName, callback);
    // 如果没有事件回调函数，则添加一个
    if (!window.XHSEvents[eventName]) {
        window.XHSEvents[eventName] = generateCalledJsCallback(eventName);
    }
    // 参考RN,返回有remove方法移除监听的对象
    return removeCalledJsListener(eventName, callback);
}
